
export const CONTENT_CUTOFF_WINDOW_MESSAGE_TEXT = 'Your newsletter is generating. Any changes you make now\
                                                   won’t be applied until your next scheduled newsletter.'
export const CONTENT_EDIT_WINDOW_MESSAGE_TEXT = 'Content for your upcoming newsletter is ready for review.'
export const SHOW_CONTENT_CUTOFF_WINDOW_MESSAGE = 'SHOW_CONTENT_CUTOFF_WINDOW_MESSAGE'
export const SHOW_CONTENT_EDIT_WINDOW_MESSAGE = 'SHOW_CONTENT_EDIT_WINDOW_MESSAGE'



// WEBPACK FOOTER //
// ./src/config/constants.ts